(function () {
  if (window.__dfnVariantFallbackRefreshLoaded) return;
  window.__dfnVariantFallbackRefreshLoaded = true;

  var FALLBACK_SELECTOR =
    'input[data-auto-fallback-selected="true"], option[data-auto-fallback-selected="true"]';

  var scheduled = false;
  var processedNodes = new WeakSet();

  function getControl(element) {
    if (!element) return null;

    if (element.matches && element.matches('option')) {
      return element.closest('select');
    }

    return element;
  }

  function activateFallback(element) {
    if (!element || processedNodes.has(element)) return;

    var control = getControl(element);
    if (!control) return;

    processedNodes.add(element);

    if (control.matches('input[type="radio"]')) {
      control.checked = true;
    }

    if (control.matches('select')) {
      control.value = element.value;
    }

    control.dispatchEvent(
      new Event('input', {
        bubbles: true
      })
    );

    control.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }

  function runFallbackRefresh() {
    document.querySelectorAll(FALLBACK_SELECTOR).forEach(function (element) {
      activateFallback(element);
    });
  }

  function scheduleFallbackRefresh() {
    if (scheduled) return;

    scheduled = true;

    window.setTimeout(function () {
      runFallbackRefresh();
      scheduled = false;
    }, 80);

    window.setTimeout(runFallbackRefresh, 250);
    window.setTimeout(runFallbackRefresh, 600);
    window.setTimeout(runFallbackRefresh, 1200);
  }

  document.addEventListener(
    'change',
    function () {
      scheduleFallbackRefresh();
    },
    true
  );

  var observer = new MutationObserver(function (mutations) {
    var shouldRun = false;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) return;

        if (node.matches && node.matches(FALLBACK_SELECTOR)) {
          shouldRun = true;
        }

        if (node.querySelector && node.querySelector(FALLBACK_SELECTOR)) {
          shouldRun = true;
        }
      });
    });

    if (shouldRun) {
      scheduleFallbackRefresh();
    }
  });

  function initFallbackRefresh() {
    scheduleFallbackRefresh();

    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFallbackRefresh);
  } else {
    initFallbackRefresh();
  }

  document.addEventListener('shopify:section:load', scheduleFallbackRefresh);
})();